const state = {
  isLoading: false,
  erpStatus: '',
};

export default state;
